import { X } from "lucide-react";
import { useState } from "react";

import { Layout } from "@/components/layout";

export function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>("All");

  const categories = ["All", "Villas", "Beach", "Dining", "Spa", "Pool"];

  const images = [
    {
      url: "https://images.pexels.com/photos/5608202/pexels-photo-5608202.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Villas",
      alt: "Beachfront Villa Ocean View",
    },
    {
      url: "https://images.pexels.com/photos/5608203/pexels-photo-5608203.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Villas",
      alt: "Luxury Villa Interior",
    },
    {
      url: "https://images.pexels.com/photos/5608201/pexels-photo-5608201.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Pool",
      alt: "Beachfront Pool",
    },
    {
      url: "https://images.pexels.com/photos/594077/pexels-photo-594077.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Beach",
      alt: "Sunset Beach View",
    },
    {
      url: "https://images.pexels.com/photos/458541/pexels-photo-458541.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Pool",
      alt: "Infinity Pool Paradise",
    },
    {
      url: "https://images.pexels.com/photos/13281334/pexels-photo-13281334.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Beach",
      alt: "Palm Trees and Beach",
    },
    {
      url: "https://images.pexels.com/photos/19533265/pexels-photo-19533265.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Dining",
      alt: "Beachfront Dining Experience",
    },
    {
      url: "https://images.pexels.com/photos/2566037/pexels-photo-2566037.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Dining",
      alt: "Fine Dining Setup",
    },
    {
      url: "https://images.pexels.com/photos/4946440/pexels-photo-4946440.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Dining",
      alt: "Fresh Seafood",
    },
    {
      url: "https://images.pexels.com/photos/5266394/pexels-photo-5266394.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Spa",
      alt: "Spa Massage Treatment",
    },
    {
      url: "https://images.pexels.com/photos/3997993/pexels-photo-3997993.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Spa",
      alt: "Facial Treatment",
    },
    {
      url: "https://images.pexels.com/photos/6724357/pexels-photo-6724357.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Spa",
      alt: "Spa Aromatherapy",
    },
    {
      url: "https://images.pexels.com/photos/11434418/pexels-photo-11434418.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Villas",
      alt: "Villa at Sunset",
    },
    {
      url: "https://images.pexels.com/photos/9482126/pexels-photo-9482126.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Beach",
      alt: "Aerial Beach View",
    },
    {
      url: "https://images.pexels.com/photos/11434413/pexels-photo-11434413.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Beach",
      alt: "Tropical Paradise",
    },
    {
      url: "https://images.pexels.com/photos/34790496/pexels-photo-34790496.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Pool",
      alt: "Luxury Pool",
    },
    {
      url: "https://images.pexels.com/photos/221457/pexels-photo-221457.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Pool",
      alt: "Mountain View Pool",
    },
    {
      url: "https://images.pexels.com/photos/8922201/pexels-photo-8922201.jpeg?auto=compress&cs=tinysrgb&w=800",
      category: "Dining",
      alt: "Bar Lounge",
    },
  ];

  const filteredImages =
    selectedCategory === "All" ? images : images.filter((img) => img.category === selectedCategory);

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[350px]">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/11434418/pexels-photo-11434418.jpeg?auto=compress&cs=tinysrgb&w=1920)",
          }}
        >
          <div className="absolute inset-0 bg-black/40" />
        </div>

        <div className="relative h-full flex items-center justify-center text-center px-6">
          <div className="max-w-3xl">
            <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-4 tracking-tight">
              Gallery
            </h1>
            <p className="text-xl text-white/95 font-light tracking-wide">
              A visual journey through The Amor
            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 px-6 bg-white border-b border-stone-200 sticky top-[73px] z-40">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 text-sm tracking-wider uppercase font-semibold transition-colors ${
                  selectedCategory === category
                    ? "bg-stone-900 text-white"
                    : "bg-stone-100 text-stone-700 hover:bg-stone-200"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 px-6 bg-stone-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredImages.map((image, index) => (
              <div
                key={index}
                className="relative group cursor-pointer overflow-hidden aspect-square"
                onClick={() => setSelectedImage(image.url)}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                  <span className="text-white text-sm tracking-wider uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    View Image
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-sm">{image.alt}</p>
                  <p className="text-white/70 text-xs tracking-wider uppercase">{image.category}</p>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div className="text-center py-16">
              <p className="text-stone-600 text-lg">No images found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-stone-300 transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <X size={32} />
          </button>
          <img
            src={selectedImage}
            alt="Gallery Image"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </Layout>
  );
}
